import { Box, Grid } from '@material-ui/core';
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import styled from 'styled-components';
import {
    getCurrencySymbol,
    isMobileDevice,
    setCurrencyFormat, 
    setCurrencyFormatWithoutSymbol, 
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { sizes } from 'src/styles/Media.styled';
const SummaryContainer = ({
    nonTissueSummary,
    tissueSummary,
    isUSUser,
    paddingBottom,
    //overridenDiscount,
}) => {
    const { t: translation } = useTranslation();
    const [tissue] = useState(true);
    const [nonTissue] = useState(true);
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    const currencyISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.currencyISOCode
    );
    // useEffectWithErrorLogging(() => {
    //     //console.log("overridenDiscount==>",overridenDiscount);
    //     products.filter(
    //         (item) =>
    //             item.salesOrg == TISSUE_AND_NON_TISSUE_SALES_ORG.tissue &&
    //             (item.discount > 0 ) // || overridenDiscount > 0)
    //     ).length > 0
    //         ? setTissue(true)
    //         : setTissue(false);
    //     products.filter(
    //         (item) =>
    //             item.salesOrg == TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue &&
    //             (item.discount > 0) // || overridenDiscount > 0)
    //     ).length > 0
    //         ? setNonTissue(true)
    //         : setNonTissue(false);
    // }, [products]);//, overridenDiscount]);
    const SummaryContent = ({
        title,
        qty,
        orgAmount,
        distAmcount,
        total,
        isDiscountAmount,
        isTotal,
    }) => (
        <Grid
            container
            className={classes.contentPadding}
            justifyContent={'space-between'}
        >
            <Grid
                className={
                    total ? classes.summaryTotal : classes.summaryContent
                }
                item
                sm={4}
                xs={4}
            >
                <CustomLabel
                    styles={{
                        textAlign: 'left',
                        fontSize: total ? '16px' : '14px',
                        fontFamily: total
                            ? 'AvenirNextWorld Demi'
                            : 'AvenirNextWorld Regular',
                        color: total ? '#140F4B' : '#393939',
                    }}
                    label={title}
                />
            </Grid>
            <Grid
                container
                className={
                    total ? classes.summaryTotal : classes.summaryContent
                }
                sm={4}
                xs={8}
            >
                <Grid item xs={6}>
                    <CustomLabel
                        styles={{
                            textAlign: 'center',
                            fontSize: total ? '16px' : '14px',
                            fontFamily: total
                                ? 'AvenirNextWorld Demi'
                                : 'AvenirNextWorld Regular',
                            color: total ? '#140F4B' : '#393939',
                        }}
                        label={qty}
                    />
                </Grid>
                <Grid
                    className={
                        total ? classes.summaryTotal : classes.amountContent
                    }
                    item
                    xs={6}
                >
                    <TextDecoration
                        textdecoration={
                            isDiscountAmount ? 'line-through' : 'none'
                        }
                    >
                        <CustomLabel
                            styles={{
                                textAlign: 'end',
                                color: isDiscountAmount ? '#E5047E' : '#202124',
                                fontSize: total ? '16px' : '14px',
                                fontFamily: total
                                    ? 'AvenirNextWorld Demi'
                                    : 'AvenirNextWorld regular',
                                letterSpacing: '0px',
                                lineHeight: '20px',
                                //textDecoration: isDiscountAmount ? 'line-through #E5047E' : 'none',
                            }}
                            label={setCurrencyFormatWithoutSymbol(orgAmount)}
                        />
                    </TextDecoration>
                    {isDiscountAmount ? (
                        <CustomLabel
                            styles={{
                                textAlign: 'end',
                                color: total ? '#140F4B' : '#202124',
                                // color: '#202124 !important' ,
                                lineHeight: '18px',
                                fontSize: total ? '16px' : '14px',
                                fontFamily: total
                                    ? 'AvenirNextWorld Demi'
                                    : 'AvenirNextWorld regular',
                            }}
                            label={setCurrencyFormatWithoutSymbol(distAmcount)}
                        />
                    ) : null}
                </Grid>
            </Grid>
        </Grid>
    );
    const formatCurrency = (amt) =>
        // new Intl.NumberFormat(undefined, {
        //     style: 'currency',
        //     currency: 'USD',
        // }).format(amt);
        setCurrencyFormat(amt);
    const classes = useStyles();
    nonTissueSummary.qty = parseInt(nonTissueSummary.qty);
    tissueSummary.qty = parseInt(tissueSummary.qty);
    let varianceAmount = 0;
    if (nonTissueSummary.discountAmt >= 0) {
        varianceAmount +=
            nonTissueSummary.orignalAmt - nonTissueSummary.discountAmt;
    }
    if (tissueSummary.discountAmt >= 0) {
        varianceAmount += tissueSummary.orignalAmt - tissueSummary.discountAmt;
    }

    varianceAmount = parseFloat(varianceAmount).toFixed(2);

    const varianceDiscount = parseFloat(
        (varianceAmount * 100) /
            (nonTissueSummary.orignalAmt + tissueSummary.orignalAmt)
    ).toFixed(2);

    const nonTissueDistAmount = !(
        nonTissueSummary.orignalAmt === nonTissueSummary.discountAmt
    )
        ? nonTissueSummary.discountAmt
        : -1;

    const tissueDistAmount = !(
        tissueSummary.orignalAmt === tissueSummary.discountAmt
    )
        ? tissueSummary.discountAmt
        : -1;

    return (
        <div
            style={{
                paddingBottom: paddingBottom
                    ? paddingBottom
                    : isMobileDevice
                    ? '50px'
                    : '30px',
            }}
        >
            <Box
                className={
                    isCondensedView ? classes.condensedPaper : classes.paper
                }
                my={1}
                bgcolor={'#ffffff'}
                boxShadow={2}
                borderRadius={6}
            >
                <Grid container justifyContent={'space-between'}>
                    <Grid
                        className={
                            isCondensedView &&
                            window.innerWidth > sizes.mobileDevice
                                ? classes.condensedSummaryUI
                                : isCondensedView &&
                                  window.innerWidth < sizes.mobileDevice
                                ? classes.condensedSummaryUIMobile
                                : classes.summaryHeader
                        }
                        item
                        sm={4}
                        xs={4}
                    >
                        <text>
                            {translation(
                                'equity.priceOverride.summaryConainer.summary'
                            )}
                        </text>
                    </Grid>
                    <Grid container sm={4} xs={8}>
                        <Grid
                            className={
                                isCondensedView &&
                                window.innerWidth > sizes.mobileDevice
                                    ? classes.condensedQtyHeader
                                    : isCondensedView &&
                                      window.innerWidth < sizes.mobileDevice
                                    ? classes.condensedQtyHeaderMobile
                                    : classes.qtyHeader
                            }
                            item
                            xs={6}
                        >
                            <text>
                                {translation(
                                    'equity.priceOverride.overrideTableHeader.quantity'
                                )}
                            </text>
                        </Grid>
                        <Grid
                            className={
                                isCondensedView &&
                                window.innerWidth > sizes.mobileDevice
                                    ? classes.condensedAmountHeader
                                    : isCondensedView &&
                                      window.innerWidth < sizes.mobileDevice
                                    ? classes.condensedAmountHeaderMobile
                                    : classes.amountHeader
                            }
                            item
                            xs={6}
                        >
                            <text>
                                {`${translation(
                                    'equity.priceOverride.summaryConainer.amount'
                                )} ${getCurrencySymbol(currencyISOCode)}`}
                            </text>
                        </Grid>
                    </Grid>

                    <SummaryContent
                        total={false}
                        title={
                            isUSUser
                                ? translation(
                                      'equity.priceOverride.summaryConainer.nonTissue'
                                  )
                                : isCondensedView
                                ? 'Products'
                                : translation('common.itemsLabel')
                        }
                        qty={nonTissueSummary.qty}
                        orgAmount={nonTissueSummary.orignalAmt}
                        distAmcount={nonTissueDistAmount}
                        // distAmount={
                        //     !(
                        //         nonTissueSummary.orignalAmt ===
                        //         nonTissueSummary.discountAmt
                        //     )
                        //         ? nonTissueSummary.discountAmt
                        //         : null
                        // }
                        isDiscount={false}
                        isDiscountAmount={
                            nonTissueDistAmount >= 0 && nonTissue ? true : false
                        }
                    />
                    {isUSUser && (
                        <SummaryContent
                            total={false}
                            title={translation(
                                'equity.priceOverride.summaryConainer.tissue'
                            )}
                            qty={tissueSummary.qty}
                            orgAmount={tissueSummary.orignalAmt}
                            distAmcount={tissueDistAmount}
                            // distAmount={
                            //     !(
                            //         tissueSummary.orignalAmt ===
                            //         tissueSummary.discountAmt
                            //     )
                            //         ? tissueSummary.discountAmt
                            //         : null
                            // }
                            isDiscount={false}
                            isDiscountAmount={
                                tissueDistAmount >= 0 && tissue ? true : false
                            }
                        />
                    )}
                    {(nonTissueDistAmount >= 0 && nonTissue) ||
                    (tissueDistAmount >= 0 && tissue) ? (
                        <Grid
                            container
                            className={classes.contentPadding}
                            justifyContent={'space-between'}
                        >
                            <Grid
                                className={classes.variance}
                                item
                                sm={6}
                                xs={6}
                            >
                                <CustomLabel
                                    styles={{
                                        textAlign: 'left',
                                        fontFamily: 'AvenirNextWorld Regular',
                                    }}
                                    label={
                                        `${translation(
                                            'equity.priceOverride.summaryConainer.variance'
                                        )} (-` +
                                        varianceDiscount +
                                        '%)'
                                    }
                                    // label={'Variance ('+''+varianceDiscount+'%)'}
                                    // label={(!(nonTissueSummary.discountAmt>0)  && !(tissueSummary.discountAmt>0))?'Variance ('+''+'0%)': 'Variance ('+''+ varianceDiscount+'%)'}
                                />
                            </Grid>
                            <Grid
                                className={
                                    isCondensedView
                                        ? window.innerWidth > sizes.mobileDevice
                                            ? classes.condensedSummaryTotal
                                            : classes.condensedSummaryTotalMobile
                                        : classes.summaryTotal
                                }
                                item
                                xs={6}
                            >
                                <CustomLabel
                                    styles={{
                                        textAlign: 'end',
                                        color: '#E5047E',
                                        fontSize: '16px',
                                        fontFamily: 'AvenirNextWorld Regular',
                                        letterSpacing: '0px',
                                        lineHeight: '20px',
                                    }}
                                    label={
                                        nonTissueDistAmount < 0 &&
                                        tissueDistAmount < 0
                                            ? setCurrencyFormat(0)
                                            : '-' + setCurrencyFormatWithoutSymbol(varianceAmount)
                                    }
                                />
                            </Grid>
                        </Grid>
                    ) : null}

                    <SummaryContent
                        total
                        title={translation(
                            'equity.priceOverride.summaryConainer.total'
                        )}
                        qty={nonTissueSummary.qty + tissueSummary.qty}
                        orgAmount={
                            nonTissueSummary.orignalAmt +
                            tissueSummary.orignalAmt
                        }
                        distAmcount={
                            nonTissueDistAmount >= 0 || tissueDistAmount >= 0
                                ? nonTissueSummary.orignalAmt +
                                  tissueSummary.orignalAmt -
                                  varianceAmount
                                : 0
                        }
                        isDiscountAmount={
                            (nonTissueDistAmount >= 0 && nonTissue) ||
                            (tissueDistAmount >= 0 && tissue)
                                ? true
                                : false
                        }
                    />
                </Grid>
            </Box>
        </div>
    );
};

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    contentPadding: {
        paddingTop: '12px',
    },
    paper: {
        padding: '16px 20px 20px 16px',
    },
    condensedPaper: {
        padding: '16px 20px 20px 21px',
    },
    summaryHeader: {
        textAlign: 'left',
        color: '#202124',
        fontSize: '16px',
        fontFamily: 'AvenirNextWorld Demi',
        letterSpacing: '0.1px',
        lineHeight: '23px',
    },
    qtyHeader: {
        textAlign: 'center',
        color: '#4F4F4F',
        fontSize: '13px',
        fontFamily: 'AvenirNextWorld Demi',
        letterSpacing: '0.1px',
        lineHeight: '23px',
    },
    amountHeader: {
        textAlign: 'end',
        color: '#4F4F4F',
        fontSize: '13px',
        fontFamily: 'AvenirNextWorld Demi',
        letterSpacing: '0.1px',
        lineHeight: '23px',
    },
    condensedSummaryUI: {
        textAlign: 'left',
        color: '#030330',
        fontSize: '16px',
        fontFamily: 'AvenirNextWorld Demi',
        letterSpacing: '0.1px',
        lineHeight: '23px',
    },
    condensedSummaryUIMobile: {
        textAlign: 'left',
        color: '#030330',
        fontSize: '14px',
        fontFamily: 'AvenirNextWorld Demi',
        letterSpacing: '0.1px',
        lineHeight: '23px',
    },

    condensedQtyHeader: {
        textAlign: 'center',
        color: '#030330',
        fontSize: '16px',
        fontFamily: 'AvenirNextWorld Demi',
        letterSpacing: '0.1px',
        lineHeight: '23px',
    },
    condensedQtyHeaderMobile: {
        textAlign: 'center',
        color: '#030330',
        fontSize: '14px',
        fontFamily: 'AvenirNextWorld Demi',
        letterSpacing: '0.1px',
        lineHeight: '23px',
    },
    condensedAmountHeader: {
        textAlign: 'end',
        color: '#030330',
        fontSize: '16px',
        fontFamily: 'AvenirNextWorld Demi',
        letterSpacing: '0.1px',
        lineHeight: '23px',
    },
    condensedAmountHeaderMobile: {
        textAlign: 'end',
        color: '#030330',
        fontSize: '14px',
        fontFamily: 'AvenirNextWorld Demi',
        letterSpacing: '0.1px',
        lineHeight: '23px',
    },
    summaryContent: {
        textAlign: 'left',
        color: '#393939',
        fontSize: '14px',
        fontFamily: 'AvenirNextWorld Regular',
        letterSpacing: '0px',
        lineHeight: '24px',
    },

    summaryTotal: {
        color: '#140F4B',
        fontSize: '16px',
        fontFamily: 'AvenirNextWorld Demi',
        letterSpacing: '-0.13px',
        lineHeight: '23px',
    },
    condensedSummaryTotal: {
        color: '#140F4B',
        fontSize: '18px',
        fontFamily: 'AvenirNextWorld Demi',
        letterSpacing: '-0.13px',
        lineHeight: '23px',
    },
    condensedSummaryTotalMobile: {
        color: '#140F4B',
        fontSize: '14px',
        fontFamily: 'AvenirNextWorld Demi',
        letterSpacing: '-0.13px',
        lineHeight: '23px',
    },
    variance: {
        textAlign: 'left',
        color: '#E5047E',
        fontSize: '16px',
        fontFamily: 'AvenirNextWorld Demi',
        letterSpacing: '0px',
        lineHeight: '24px',
    },
    gridPadBottom: {
        paddingBottom: 8,
    },
}));

const TextDecoration = styled.div`
    text-decoration: ${({ textdecoration }) => textdecoration};
    -webkit-text-decorations-in-effect: ${({ textdecoration }) =>
        textdecoration};
    color: #e5047e;
`;

export default SummaryContainer;
